import {isNullOrUndef} from "chart.js/helpers";
import '../utils/sweetalert_setup';
// import I18n from 'i18n-js';
// I18n.locale = window.I18n.locale;

function initVehicleSearch() {
    // Asegurar URL
    let searchUrl = $('.vehicle-ajax-search').data('url');

    // 500 milisegundos de retraso
    setTimeout(function() {

        let $select = $('.vehicle-ajax-search');

        // // Destruye cualquier instancia previa
        // if ($select.hasClass("select2-hidden-accessible")) {
        //     $select.select2('destroy');
        // }
        // // Desconecta cualquier evento fantasma
        // $select.off('select2:select');
        // // Limpia opciones HTML (Caché basura de Turbolinks)
        // $select.empty();


        $select.select2({
            placeholder: 'Escriba para buscar (ej. 2018 Nissan Versa)...',
            allowClear: true,
            theme: "classic",
            width: 'resolve',
            minimumInputLength: 2,
            ajax: {
                url: searchUrl,
                dataType: 'json',
                delay: 250,
                data: function(params) {
                    // console.log("Buscando:", params.term);
                    return { q: params.term };
                },
                processResults: function(data) {
                    console.log("Resultado:", data.results);
                    return { results: data.results };
                },
                cache: true
            }
        });

        $select.on('select2:select', function (e) {
            let data = e.params.data;
            let target = document.getElementById('bci-recomendado');
            if (target) {
                target.innerText = data.bcis ? 'BCI Recomendado: ' + data.bcis : 'Sin BCI recomendado';
            }
        });
        $select.on('select2:unselect', function (e) {
            let target = document.getElementById('bci-recomendado');
            if (target) {
                target.innerText = '';
            }
        });
    }, 500);
}

function initBatterySearch() {
    // Asegurar URL
    let searchUrl = $('.battery-ajax-search').data('url');

    // 500 milisegundos de retraso
    setTimeout(function() {

        let $select = $('.battery-ajax-search');
        // // Destruye cualquier instancia previa
        // if ($select.hasClass("select2-hidden-accessible")) {
        //     $select.select2('destroy');
        // }
        // // Desconecta cualquier evento fantasma
        // $select.off('select2:select');
        // // Limpia opciones HTML (Caché basura de Turbolinks)
        // $select.empty();


        $select.select2({
            placeholder: 'Escriba para buscar (ej. Ponce Battery Conmemorativa 99)...',
            allowClear: true,
            theme: "classic",
            width: 'resolve',
            minimumInputLength: 2,
            ajax: {
                url: searchUrl,
                dataType: 'json',
                delay: 250,
                data: function(params) {
                    // console.log("Buscando:", params.term);
                    return { q: params.term };
                },
                processResults: function(data) {
                    console.log("Resultado:", data.results);
                    return { results: data.results };
                },
                cache: true
            }
        });

        $select.on('select2:select', function (e) {
            let data = e.params.data;
            setBatteryData(data.warranty, data.warranty_fleet, data.list_price, data.list_price_iva,
                           data.list_price_currency, data.list_price_iva_currency)
        });
        $select.on('select2:unselect', function (e) {
            let target = document.getElementById('bci-recomendado');
            setBatteryData(null, null, null, null, null, null)
        });
    }, 500);
}

function setBatteryData(warranty, warranty_fleet, list_price, list_price_iva,
                        list_price_currency, list_price_iva_currency) {
    $('#model_warranty').val(warranty)
    $('#model_warranty_fleet').val(warranty_fleet)
    $('#model_list_price').val(list_price)
    $('#model_list_price_iva').val(list_price_iva)
    $('#warranty_price').val(list_price_iva)

    $('#show_warranty').val(warranty)
    $('#show_warranty_fleet').val(warranty_fleet)
    $('#show_list_price').val(list_price_currency)
    $('#show_list_price_iva').val(list_price_iva_currency)
    if(!undefinedOrNull(warranty) && !undefinedOrNull(warranty_fleet)) {
        setWarranty()
    }
}

function setWarranty() {
    let checked = $('#warranty_fleet') && $('#warranty_fleet').prop('checked')
    if(checked) {
        $('#warranty_warranty').val($('#model_warranty_fleet').val())
    } else {
        $('#warranty_warranty').val($('#model_warranty').val())
    }
}

/**
 * Unbinds the 'select2:select' event from one or more Select2 elements.
 *
 * @param {...string} select_ids - A comma-separated list of element IDs (without the #).
 */
function clearSelect2(...select_ids) {
    if (select_ids.length === 0) {
        return;
    }
    // Build a single jQuery selector for all IDs.
    const selector = select_ids.map(id => '#' + id).join(', ');
    // Use the combined selector to turn off the event for all matched elements.
    $(selector).off('select2:select');
}

function getCustomer()  {
    $('#phone_error_message').hide();
    let phone_number = $('#warranty_phone_number').val()
    if (!phone_number || phone_number.length < 10) {
        return $.Deferred().resolve().promise();
    }
    $('#warranty_first_name').val()
    $('#warranty_last_name').val()
    $('#warranty_email').val()
    let path = '/search/customer/' + $('#warranty_phone_number').val()
    return $.get(path, {})
        .done(function(data) {
            if(!isNullOrUndef(data) && (isNullOrUndef(data.error) || data.error === false || data.error === 'false')) {
                if (data.customer) {
                    $('#warranty_phone_number').val(phone_number)
                    $('#warranty_first_name').val(data.customer.first_name)
                    $('#warranty_last_name').val(data.customer.last_name)
                    $('#warranty_email').val(data.customer.email)
                } else {
                    $('#phone_error_message').show();
                }
            } else {
                console.error('Something goes wrong while getting '+phone_number)
            }
        })
        .fail(function(jqXHR, textStatus, errorThrown) {
            console.error("Request failed:", textStatus);
            console.error("Error details:", errorThrown);
            console.log("HTTP Status Code:", jqXHR.status);
            console.log("Server Response:", jqXHR.responseText);
        });

}

const select2Ids = ['battery_group_id','battery_brand_id','battery_bci_id','battery_condition_id']

function setupWarrantiesForm() {
    const form = document.getElementById("warranties_form");
    if (form) {
        // console.log('warranties turbolinks loaded.')
        // Clear previous listeners
        // clearSelect2('battery_group_id','battery_brand_id','battery_bci_id','battery_condition_id')
        clearSelect2(...select2Ids)
        $(document)
            .on('change', '#warranty_phone_number', getCustomer)
            .on('change', '#warranty_fleet', setWarranty)
        initVehicleSearch()
        initBatterySearch()
    }
}

function destroyWarrantiesForm() {
    const form = document.getElementById("warranties_form");
    if (form) {
        // console.log("Cleanup warranties_form...")
        document.removeEventListener("turbolinks:load", setupWarrantiesForm);
        document.removeEventListener('turbolinks:before-cache', destroyWarrantiesForm)

        $(document)
            .off('change', '#warranty_phone_number', getCustomer)
            .off('change', '#warranty_fleet', setWarranty)

    }
}
document.addEventListener("turbolinks:load", setupWarrantiesForm);
// document.addEventListener('turbolinks:before-cache', destroyWarrantiesForm);
window.addEventListener('beforeunload', (event) => {
    destroyWarrantiesForm();
});

// window.checkBatterySearch = checkBatterySearch;
// window.displayBatteryList = displayBatteryList;
window.getCustomer = getCustomer;
